import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_006.jpg';

page.games = [
  {
    id: 'page006_game1',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 6',
    pos: {
      x: LEFT,
      y: 40,
    },
    item: {
      id: 'page006_game1',
    },
  },
];

export default page;
